import styled from '@emotion/styled';
import { motion } from 'framer-motion';

type SliderMotionType = {
  $gapSize: number;
};

export const SliderMotion = styled(motion.div, {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
})<SliderMotionType>`
  cursor: grab;
  display: flex;
  flex-direction: row;
  user-select: none;
  gap: ${({ $gapSize }) => ($gapSize ? `${$gapSize}rem` : '1rem')};
`;

export const SliderWrapper = styled.div`
  overflow-x: hidden;
`;
